<template lang="pug">
.article-wrap
  .left
    h2.article-list-title(v-t='"newsPage.listTitle"')
    .article-list
      //article-card
      .item-wrap(v-for='(item, index) in articleList', :key='index',)
        article-card.item-article(:info="item", target="_blank" ) {{item}}
        //- a.simple-item(v-if="!item.coverImg" :href="localePath('/article/' + item.id)", target="_blank")
        //-   .title {{item.title}}
        //-   .time {{item.gmtModified | timeFormat}}
        //- article-card.item-article(v-else :info="item", target="_blank" ) {{item}}

    fq-ignore(v-if="isEmpty")
    client-only
      infinite-loading(@infinite="infiniteHandler")
  .right
    back-top-ercode(:hasBackTop="isShowBackToTopBtn")

</template>
<script>
import { fetchArticles } from '@/api'
import articleCard from '@/components/article/article-card'
import backTopErcodeVue from '@/components/back-top-ercode.vue'
import { throttle } from 'throttle-debounce'
import config from '@/config'
import getStructuredJson from '@/util/structuredData'

export default {
  name: 'Articles',
  components: {
    'article-card': articleCard,
    'back-top-ercode': backTopErcodeVue
  },
  async asyncData({ $ua, app, redirect }) {
    try {
      const res = await app.$api.getArticleList()
      console.log('articleList res', res)
      const seoRes = await app.$api.queryKeyword()
      return {
        articleList: res.list.filter((item) => item),
        seoKeyword: seoRes.keyword
      }
    } catch (e) {
      console.log('articleList error', e)
    }
  },
  data() {
    return {
      isShowBackToTopBtn: false,
      articleList: [],
      isInfiniteLoading: false,
      page: 1,
      size: 10,
      html: ''
    }
  },
  head() {
    return {
      title: this.$t('seo.articles.title') + '- loklok news',
      meta: [
        { name: 'keywords', content: `${this.seoKeyword ? this.seoKeyword + ',' : ''}${this.$t('seo.articles.keywords')}` },
        {
          hid: 'description',
          name: 'description',
          content: this.$t('seo.articles.description') + '- loklok'
        },
        { rel: 'canonical', href: 'https://loklok.top' + this.localePath('/articles') }
      ],
      script: [
        {
          type: 'application/ld+json',
          json: [
            getStructuredJson.bread([
              { name: this.$t('seo.index.title'), path: 'https://loklok.top' + this.localePath('/') },
              { name: this.$t('seo.articles.title') + '- loklok news', path: 'https://loklok.top' + this.localePath('/articles') }
            ]),
            getStructuredJson.articleList(this.articleList)
          ]
        }
      ]
    }
  },
  filters: {
    timeFormat(timestamp) {
      const date = new Date(timestamp)
      return `${date.getFullYear()}.${date.getMonth() + 1}.${date.getDate()}`
    }
  },
  computed: {
    isEmpty() {
      return this?.articleList?.length === 0
    }
  },
  methods: {
    async infiniteHandler($state) {
      if (this.isInfiniteLoading) return
      this.isInfiniteLoading = true
      const list = await this.load()
      this.articleList.push(...list)
      if (list?.length < this.size) {
        $state && $state.complete()
      } else {
        $state && $state.loaded()
      }
      this.isInfiniteLoading = false
    },
    async load() {
      try {
        const res = await this.$api.getArticleList(this.page++, this.size)
        return res?.list?.filter((item) => item)
      } catch (e) {
        return []
      }
    },
    watchScroll() {
      document.addEventListener(
        'scroll',
        throttle(300, () => {
          var scrollY = document.documentElement.scrollTop || document.body.scrollTop
          if (scrollY > 1200) {
            !this.isShowBackToTopBtn && (this.isShowBackToTopBtn = true)
          } else {
            this.isShowBackToTopBtn && (this.isShowBackToTopBtn = false)
          }
        })
      )
    }
  },
  watch: {},
  mounted() {
    this.watchScroll()
  }
}
</script>

<style lang="sass" scoped>

.article-wrap
  width: 1180px
  margin: 0 auto
  padding-top: 20px
  @include flex-between
  align-items: flex-start
  .left
    width: 1000px
    .article-list-title
      font-weight: bold
      font-size: 14px
      line-height: 120%
      color: $mainDescTextColor
      margin-bottom: 20px
    .article-list
      .item-wrap
        padding-bottom: 40px
        .simple-item
          display: flex
          justify-content: space-between
          align-items: center
          font-size: 16px
          color: #DEE4E9
          cursor: pointer
          .title
            font-weight: bold
            &:hover
              color: #CC3648
          .time
            font-size: 12px
            color: #81868E
            user-select: none
  .right
    width: 160px
    position: sticky
    top: 90px
    img
      width: 260px
      border-radius: 4px
@media screen and (max-width: 1240px)
  .article-wrap
    width: 100%
    padding: 20px 30px 0
    justify-content: center
    .right
      position: fixed
      right: 60px
      top: auto
      bottom: 80px
@media screen and (max-width: 750px)
  .article-wrap
    width: 100%
    padding: 20px 16px 0
    justify-content: center
    .left
      width: 100%
      margin-bottom: 20px
      img
        width: 100px !important
    .right
      display: none
</style>
